'use client';

import React from 'react';
import GameDetailsContent from '@/app/dashboard/settings/game-management/components/game-details-content';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';

import { GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function GameDetailsDrawer(): React.JSX.Element | null {
  const { drawerState } = useAppSelector(getUi);

  const dispatch = useAppDispatch();

  return (
    <DrawerTemplate
      open={drawerState.GENERAL_GAME_DETAILS}
      onClose={() => {
        dispatch(hideDrawerState(GeneralDrawer.GENERAL_GAME_DETAILS));
      }}
      title="Game Details"
      width="1780px"
    >
      <GameDetailsContent />
    </DrawerTemplate>
  );
}
